module.exports = __webpack_public_path__ + "img/dcg.c752a2e.png";